import { useAppSelector } from "../../util/hooks";
import CadastrarPage from "./pages/cadastrar";
import GeralPage from "./pages/geral";

const pages: any = {
  geral: GeralPage,
  cadastrar: CadastrarPage,
};

const RateioCentroCustoPageController = () => {
  //estados globais
  const rateioCentroCustoState = useAppSelector((state) => state.rateioCentroCusto);

  const Page = pages[rateioCentroCustoState.page];

  return <Page key={rateioCentroCustoState.page} />;
};

export default RateioCentroCustoPageController;
